module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGamesJoined/nfl/survive-84972f9d5ed1431ca87ea3460b870494.svg";